const capitalize = (s?: string) => (s?.length ? s[0].toUpperCase().concat(s.slice(1)) : '');

export { capitalize };
